import * as actions from '../utils/Constants';
import { getJurisdictions } from './Jurisdictions';

const api = `${process.env.REACT_APP_API_HOST}api/jurisdiction/`;

export const newJurisdiction = () => {
    return {
        type: actions.NEW_JURISDICTION
    }
}

export const updateJurisdictionName = (name) => {
    return {
        type: actions.UPDATE_JURISDICTION_NAME,
        payload: name
    }
}

export const updateJurisdictionState = (state) => {
    return {
        type: actions.UPDATE_JURISDICTION_STATE,
        payload: state
    }
}

export const updateJurisdictionCity = (city) => {
    return {
        type: actions.UPDATE_JURISDICTION_CITY,
        payload: city
    }
}

export const updateJurisdiction = (field, value) => ({
    type: actions.UPDATE_JURISDICTION,
    payload: {field, value}
})

export const saveJurisdiction = (jurisdiction) => {
    return dispatch => dispatch({
        type: actions.SAVE_JURISDICTION,
        payload: fetch(api, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(jurisdiction)
        }).then(res => {
            dispatch(getJurisdictions());
            return res.json();
        }
        )
    })
}
